module.exports = __webpack_public_path__ + "static/media/icon-star.2ff3e264.png";